import { ReportInvoiceCreateDto, ReportWithDatesAssigneeAndContactDto, ReportTaxCreateDto } from 'models';
import { PostFactory } from './base.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'reports';
const SERVICE_NAME = 'Report';

export interface GetAllParams extends BaseGetAllParams {}

export const ShiftsReport = PostFactory<ReportWithDatesAssigneeAndContactDto>(`${BASE_URL}/shifts`, SERVICE_NAME);
export const KmsReport = PostFactory<ReportWithDatesAssigneeAndContactDto>(`${BASE_URL}/kms`, SERVICE_NAME);
export const TaxReport = PostFactory<ReportTaxCreateDto>(`${BASE_URL}/tax`, SERVICE_NAME);
export const InvoiceReport = PostFactory<ReportInvoiceCreateDto>(`${BASE_URL}/invoices`, SERVICE_NAME);
